<template>
  <b-container fluid id="chartContainer" style="margin-bottom: 20px">
    <b-row style="margin-bottom: 20px;">
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addLandscapingHeaders(waterChartData)"
            :options="getLandscapingOptions(1)"

        />
        <GChart
            type="LineChart"
            :data="addProcessHeaders(waterChartData)"
            :options="getProcessOptions(1)"

        />

        <GChart
            type="LineChart"
            :data="addTastingHeaders(waterChartData)"
            :options="getTastingOptions(1)"

        />

        <GChart
            type="LineChart"
            :data="addWastewaterHeaders(waterChartData)"
            :options="getWastewaterOptions(1)"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addSolarHeaders(powerData)"
            :options="getSolarOptions(1)"

        />
        <GChart
            type="LineChart"
            :data="addElectricMeter1Headers(powerData)"
            :options="getElectricOptions(1, 'orange')"

        />

        <GChart
            type="LineChart"
            :data="addElectricMeter2Headers(powerData)"
            :options="getElectricOptions(2,'gray')"

        />


        <GChart
            type="LineChart"
            :data="addElectricMeter3Headers(powerData)"
            :options="getElectricOptions(3,'purple')"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addGasHeaders(gasData)"
            :options="getNaturalGasOptions('tan')"

        />
        <GChart
            type="LineChart"
            :data="addPropaneHeaders(gasData)"
            :options="getPropaneOptions(1, 'darkgrey')"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-col cols="12">
        <ElectricMetricTable :groupId="theGroup"></ElectricMetricTable>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <WaterMetricTable :groupId="theGroup"></WaterMetricTable>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <GasMetricTable :groupId="theGroup"></GasMetricTable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {GChart} from 'vue-google-charts'
import ElectricMetricTable from "./ElectricMetricTable";
import WaterMetricTable from "./WaterMetricTable";
import GasMetricTable from "./GasMetricTable";

Date.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


export default {
  name: "ResourceGraphs",
  components: {
    ElectricMetricTable,
    GChart,
    WaterMetricTable,
    GasMetricTable
  },
  props: {
    groupId: String
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "TabbedMetrics" && Object.keys(to.params).length === 0) {
      next({name: "TabbedMetrics", params: {groupId: this.theGroup}})
    } else if (to.name === "Metrics Summary" && Object.keys(to.params).length === 0) {
      next({name: "Metrics Summary", params: {groupId: this.theGroup}})
    } else {
      next()
    }

  },
  data() {
    return {
      showGasInfo: false,
      electricRows: {},
      waterRows: {},
      powerData: [],
      waterData: [],
      gasData: [],
      propaneData: [],
      waterChartData: {},
      theGroup: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      chartHeight: '70%',
      chartWidth: '70%',
      chartWrapperHeight: 500,
      chartWrapperWidth: '90%'
    }
  },
  computed: {
    landscapeMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'landscaping');
    },
    solarMax: function () {
      return this.calculateMaxChartYValue(this.powerData, 'solarProductivity');
    },
    electricMax: function () {
      return this.calculateMaxChartYValue(this.powerData, 'electricMeter');
    },
    electric1Max: function () {
      return this.calculateMaxChartYValue(this.powerData, 'electricMeter');
    },
    electric2Max: function () {
      return this.calculateMaxChartYValue(this.powerData, 'electricMeter2');
    },
    electric3Max: function () {
      return this.calculateMaxChartYValue(this.powerData, 'electricMeter3');
    },//wineryProcess
    processMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'wineryProcess');
    },
    wasteWaterMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'wastewater');
    },
    tastingOfficesMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'tastingOffices');
    },
    propaneMax: function () {
      return this.calculateMaxChartYValue(this.gasData, 'propaneMeter');
    },
    naturalGasMax: function () {
      return this.calculateMaxChartYValue(this.gasData, 'gasMeter');
    }
  },
  mounted() {
    this.$http.get("metrics/water/graph/full/" + this.theGroup)
        .then(result => {
          this.waterChartData = result.data;
        }).catch(error => {
      console.log(error);
    });

    this.$http.get("metrics/power/graph/" + this.theGroup)
        .then(result => {
          this.powerData = result.data;
        }).catch(error => {
      console.log(error);
    });

    this.$http.get("metrics/gas/graph/" + this.theGroup)
        .then(result => {
          this.gasData = result.data;
        }).catch(error => {
      console.log(error);
    });
    this.showGasInfo = this.$route.query.showGas !== undefined;

  },
  methods: {
    calculateMaxChartYValue: function (data, fieldName) {
      let max = 1000;
      if (data && Array.isArray(data)) {
        data.forEach(val => {
          if (val[fieldName] > max) {
            max = Math.floor(val[fieldName] * 1.10);
          }
        });
      }
      console.log(`${fieldName} Max:  + ${max}`);
      return max;
    },
    addHeaders(data) {
      let theData = [['Month', 'Winery Process', 'Tasting/Offices', 'Landscaping']];
      data.forEach(function (element) {
        theData.push([element.meterUsage, element.wineryProcess, element.tastingOffices, element.landscaping])
      });
      return theData;
    },
    addProcessHeaders(data) {
      let self = this;
      let theData = [['Month', 'Winery Process']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.wineryProcess]);
        }
      });
      return theData;
    },
    addTastingHeaders(data) {
      let self = this;
      let theData = [['Month', 'Hospitality/Office']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.tastingOffices]);
        }
      });
      return theData;
    },
    addLandscapingHeaders(data) {
      let self = this;
      let theData = [['Month', 'Landscaping']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.landscaping]);
        }
      });
      return theData;
    },
    addWastewaterHeaders(data) {
      let self = this;
      let theData = [['Month', 'Wastewater']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.wastewater]);
        }
      });
      return theData;
    },
    addSolarHeaders(data) {
      let self = this;
      let theData = [['Month', 'Solar Productivity']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.solarProductivity]);
        }
      });
      return theData;
    },
    addElectricMeter1Headers(data) {
      let self = this;
      let theData = [['Month', 'Electric Meter']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.electricMeter]);
        }
      });

      return theData;
    },
    addElectricMeter2Headers(data) {
      let self = this;
      let theData = [['Month', 'Electric Meter 2']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.electricMeter2]);
        }
      });
      return theData;
    },
    calculateIsMonthVisible: function (element) {
      let today = new Date(Date.now());
      let year = Number.parseInt(element.meterUsage.split("-")[1], 10) + 2000;
      let isBeforeLatestMonth;
      let isAfterEarliestMonth;
      let month = Date.shortMonths.indexOf(element.meterUsage.split("-")[0]);
      let dateToCheck = new Date(year, month, 1);
      let latestDate = new Date((today.getFullYear()), today.getMonth() + 1, 1);
      let earliestDate = new Date((today.getFullYear() - 3), today.getMonth(), 1);
      isBeforeLatestMonth = latestDate.getTime() > dateToCheck.getTime();
      isAfterEarliestMonth = dateToCheck.getTime() > earliestDate.getTime();
      return isBeforeLatestMonth && isAfterEarliestMonth;
    },
    addElectricMeter3Headers(data) {
      let self = this;
      let theData = [['Month', 'Electric Meter 3']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.electricMeter3]);
        }
      });
      return theData;
    },
    addGasHeaders(data) {
      let self = this;
      let theData = [['Month', 'Gas']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.gasMeter]);
        }
      });
      return theData;
    },
    addPropaneHeaders(data) {
      let self = this;
      let theData = [['Month', 'Propane']];
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          theData.push([element.meterUsage, element.propaneMeter]);
        }
      });
      return theData;
    },
    getSolarOptions(year) {
      console.log("Getting Options");
      return {

        title: 'Winery Solar Usage - kWh/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: '60%'},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.solarMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#ff2f00'}
        }
      }
    },
    getElectricOptions(meterNumber, color) {
      console.log("Getting Options");
      let meterNumberString = meterNumber;// > 1 ? '' : meterNumber;
      return {

        title: 'Winery Electrical Meter ' + meterNumber + ' Usage - kWh/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this[`electric${meterNumberString}Max`],
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
    getOptions(year) {
      console.log("Getting Options");
      return {

        title: 'Winery Electrical Usage - kWh/Month ' + year,
        subtitle: 'Sales, Expenses, and Profit: ' + year,
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight}
      }
    },
    getProcessOptions(year) {
      console.log("Getting Options");
      let options = {

        title: 'Winery Process Water Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.processMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#43459d'}
        }
      }
      console.log("Process Options");
      console.log(options);
      return options;
    },
    getTastingOptions(year) {
      console.log("Getting Options");
      return {

        title: 'Hospitality/Office Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.tastingOfficesMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#ADD8E6'}
        }
      }
    },
    getWastewaterOptions(year) {
      console.log("Getting Options");
      return {

        title: 'Wastewater Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.wasteWaterMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#7d7dff'}
        }
      }
    },
    getLandscapingOptions(year) {
      console.log("Getting Options");
      return {

        title: 'Landscaping Water Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.landscapeMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: 'green'}
        }
      }
    },
    getNaturalGasOptions(color) {
      console.log("Getting Options");
      return {

        title: 'Natural Gas Usage - Therms/Month ',
        subtitle: 'Natural Gas Used: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.naturalGasMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
    getPropaneOptions(year, color) {
      console.log("Getting Propane Options");
      return {

        title: 'Propane Usage - Gallons/Month ',
        subtitle: 'Propane Used: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.propaneMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    }
  }
}
</script>

<style scoped>
.chart {
  width: 100%;
  min-height: 700px;
}

.rect {
  width: 100%;
}

.row {
  margin: 0 !important;
}
</style>
